import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    unClaimedData: [],
    completedData: [],
    countData: [],
    assignedData: [],
    pendingData: [],
}
const mutations = {
    SET_UNCLAIMED_TASKS(state, data) {
        state.unClaimedData = data;
    },
    DELETE_UNASSIGEND_TASKS(state, data) {
        for (var i = 0; i < data.ids.length; i++) {
            var index = state.unClaimedData.unassigned.findIndex(Element => Element.InternalTask.id == data.ids[i]);
            if (index != -1) {
                state.unClaimedData.unassigned.splice(index, 1)
            }
        }
    },
    SET_COMPLETED_DATA(state, data) {
        state.completedData = data
    },
    SET_TASKS_COUNT(state, data) {
        state.countData = data;
    },
    SET_ASSIGNED_DATA(state, data) {
        state.assignedData = data;
    },
    DELETE_ASSIGEND_TASKS(state, data) {
        if (Array.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                var index = state.assignedData.assignedData.findIndex(Element => Element.InternalTask.id == data[i]);
                if (index != -1) {
                    state.assignedData.assignedData.splice(index, 1)
                }
            }
        } else {
            var index = state.assignedData.assignedData.findIndex(Element => Element.InternalTask.id == data);
            if (index != -1) {
                state.assignedData.assignedData.splice(index, 1)
            }
        }
    },
    ADD_ASSIGNED_TASK(state, data) {
        if (state.assignedData != undefined && state.assignedData.assignedData != undefined && Object.keys(state.assignedData.assignedData).length != 0 && state.assignedData.assignedData != 'noData') {
            state.assignedData.assignedData.push(data);
        } else {
            var dataSet = {}
            dataSet = data;
            state.assignedData.assignedData = dataSet;
        }
    },
    ADD_UNASSIGNED_TASK(state, data) {
        if (Object.keys(state.unClaimedData.unassigned).length != 0 && state.unClaimedData.unassigned != 'noData') {
            state.unClaimedData.unassigned.push(data);
        } else {
            var dataSet = {}
            dataSet = data;
            state.unClaimedData.unassigned = dataSet;
        }
    },
    SET_PENDING_DATA(state, data) {
        state.pendingData = data;
    },
}
const actions = {
    clearAssignedDiscTask({
        commit,
        dispatch
    }, postData) {
        commit('DELETE_ASSIGEND_TASKS', postData);
    },
    fetchUncliamedData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.post('/tasks/get_all_unassigned_task/', qs.stringify(authData, {
            parseArrays: false
        }))
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push(res.data.message);
                } else {
                    if (authData.export == true) {
                        if (res.data.status != "success") {
                          reject(res.data.message);
                          return;
                        }
                        window.open("/backend" + res.data.message, "_blank");
                        window.focus();
                        return;
                    }
                    commit("SET_UNCLAIMED_TASKS", res.data);
                }
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })


    },
    fetchAssignedData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.post('/tasks/get_all_assigned_task/', qs.stringify(authData, {
            parseArrays: false
        }))
            .then(res => {
                Nprogress.done()
                if (authData.export == true) {
                    if (res.data.status != "success") {
                      reject(res.data.message);
                      return;
                    }
                    window.open("/backend" + res.data.message, "_blank");
                    window.focus();
                    return;
                }
                commit("SET_ASSIGNED_DATA", res.data);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })


    },
    fetchTasksCount({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        var from = null;
        var to = null;
        var vue = true;
        axios.get('/tasks/pending_users_count_list/')
            .then(res => {
                Nprogress.done()
                commit("SET_TASKS_COUNT", res.data);
            })
            .catch(error => console.log(error))


    },
    fetchCompletedData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        var from = null;
        var to = null;
        var vue = true;
        axios.get('/tasks/get_all_completed_task/' + from + '/' + to + '/' + vue)
            .then(res => {
                Nprogress.done()
                commit("SET_COMPLETED_DATA", res.data)
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })


    },
    deleteUnassignedTasks({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/delete_all_task.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    } else {
                        var successData = {
                            ids: JSON.parse(postData.taskId),
                        }
                        commit('DELETE_UNASSIGEND_TASKS', successData);
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    claimUnassignedTasks({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/claim_task.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    } else {
                        var successData = {
                            ids: JSON.parse(postData.taskId),
                        }
                        commit('DELETE_UNASSIGEND_TASKS', successData);
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    rejectAllAssignedTasks({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/reject_all_call_and_user', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    } else {
                        commit('DELETE_ASSIGEND_TASKS', postData.taskId);
                    }

                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status == 403) {
                            window.location = "/dashboard";
                        }
                    }
                });
        });
    },

    getTaskAllDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/get_task_variables', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    } else {

                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    assignedCompleteAction({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/complete_task', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    } else {
                        commit('DELETE_ASSIGEND_TASKS', postData.taskId);
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    assignedCompleteActionApprove({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/complete_task.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    } else {
                        commit('DELETE_ASSIGEND_TASKS', postData.taskId);
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchTaskOrderDetails({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/get_task_order_variables', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    } else {
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveTaskCreateOrder({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/assign_order_variables', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    } else {
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    createNewTaskSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/add_new_task', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var res = response.data;
                    if (res.resData.accountCheck == true && res.taskStatus == 'assigned') {
                        commit('ADD_ASSIGNED_TASK', response.data.commitData);
                    }

                    if (res.resData.action == 'edit') {
                        commit('DELETE_ASSIGEND_TASKS', postData.taskId);
                    }

                    if (res.resData.accountCheck == true && res.taskStatus == 'unassigned') {
                        commit('ADD_UNASSIGNED_TASK', response.data.commitData);
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    unclaimTaskSubmit({
        commit
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/tasks/unclaim_Task', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide();
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('DELETE_ASSIGEND_TASKS', postData.taskId);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchPendingData({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.post('/tasks/get_all_pending_task/', qs.stringify(authData, {
            parseArrays: false
        }))
            .then(res => {
                Nprogress.done()
                if (authData.export == true) {
                    if (res.data.status != "success") {
                        reject(res.data.message);
                        return;
                    }
                    window.open("/backend" + res.data.message, "_blank");
                    window.focus();
                    return;
                }
                commit("SET_PENDING_DATA", res.data);
            })
            .catch(error => console.log(error));
    },

}
const getters = {
    getUnclaimedDataGetter: state => {
        return state.unClaimedData;
    },
    getCompletedDataGetter: state => {
        return state.completedData;
    },
    getCountDataGetter: state => {
        return state.countData;
    },
    getAssignedGetter: state => {
        return state.assignedData;
    },
    getPendingGetter: state => {
        return state.pendingData;
    }

}
export default {
    state,
    mutations,
    actions,
    getters
}

